module.exports = __webpack_public_path__ + "img/knowImg.1fcfabcb.png";